import React, { useState, useEffect, useRef, useCallback } from "react";
import { Row, Col, Image, Tooltip, OverlayTrigger, Button, Table, Dropdown, Popover } from "react-bootstrap";
import ReactTable, { DateRangeFilter, filterDateRange, filterNoteTag, SelectNoteTagFilter } from '../ReactTable/ReactTable';
import { MoreVertical } from "lucide-react";
import { convertToBaseFormatDate, currencifyInDollars, viewDocument, viewNotesformatter } from "../../../commonservices/CommonMethods";
import { CSVLink } from "react-csv";
import { useReactToPrint } from 'react-to-print';
import filterlogo from '../../../assets/images/TableFilters/TableFilterIcon.svg';
import printlogo from '../../../assets/images/TableFilters/TableFilterPrintIcon.svg';
import exportlogo from '../../../assets/images/TableFilters/TableFilterDownloadIcon.svg';
import BorderEditIcon from '../../../assets/images/Action-Icons/Border-Edit-Icon.svg';
import CloseIcon from '../../../assets/images/Popup-Icons/PopupIcons_Delete_Note_Grey.svg';
import logo from '../../../assets/images/logo.png';
import TableFiltersWrapper from "../common/components/TableComponents/TableFiltersWrapper/TableFiltersWrapper";
import NoDataFound from "../common/components/TableComponents/NoDataFound/NoDataFound";
import InfoIcon from '../../../assets/images/info-icon-v2.svg';
import AddNoteIcon from '../../../assets/images/Popup-Icons/PopupIcons_Notes_Grey.svg';
import eyeIcon from '../../../assets/images/Action-Icons/Eye-Icon.svg'
import { useSelector } from "react-redux";
import parse from 'html-react-parser';
import callAPI from "../../../commonservices/APIRequests";
import SharedChips from "../../Shared/common/components/Chips/SharedChips";

let csvData = [];
let printRT = [];
const SharedNotesTable = (props) => {

    const printRef = useRef();
    const userDetails = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
    const partnerDetails = localStorage.getItem('partnerDetails') ? JSON.parse(localStorage.getItem('partnerDetails')) : {};

    const [notesColumn, setNotesColumn] = useState([]);
    const [showFilters, setShowFilters] = useState(false);
    const [activeTabInViewPort, setActiveTabInViewPort] = useState()

    //Print and csv states
    const [rerenderPrintData, setRerenderPrintData] = useState();
    const [rerenderCSVData, setRerenderCSVData] = useState();


    const storeData = useSelector((store) => store.sharedNotesReducer);



    const setCSVData = (filteredData, activeTabInViewPort) => {

        const tableHeaderData = props.tableData?.sharedTableHeaders && props.tableData.sharedTableHeaders.length > 0 ? props.tableData.sharedTableHeaders.filter(item => item.label !== 'Actions') : '';
        switch (activeTabInViewPort) {

            case 'Dealer Note':
                csvData = filteredData.map(item => {

                    return {
                        'Note': viewNotesformatter(item.notes),
                        'Submitted By': item.submittedBy,
                        'Created Date': convertToBaseFormatDate(item.createdAt, true),
                        'Note Tag': item.noteTag,

                    }
                })
                break;
            case 'Payment Note':
                csvData = filteredData.map(item => {
                    const data = {
                        'Submitted By': item.submittedBy,
                        'Created Date': convertToBaseFormatDate(item.createdAt, true),
                        'Note Tag': item.noteTag,
                        'VIN': item.vehicleDetails?.vin,
                        'Asset Name': item.vehicleDetails?.vehicleName,
                        'Payment Amount': currencifyInDollars(item.paymentDetails?.paymentAmount),
                        'Payment Date': convertToBaseFormatDate(item.paymentDetails?.paymentDate, false),
                        'Payment Description': item.paymentDetails?.paymentDescription,
                    }
                    if (item.paymentDetails?.paymentType){
                        data['Payment Type'] = item.paymentDetails?.paymentType
                    }
                    if (item && item.metadata && item.metadata.taskName) {
                        data['Note'] = item.metadata.taskName;
                        data['Reason'] = viewNotesformatter(item.notes);
                    } else {
                        data['Note'] = viewNotesformatter(item.notes);
                    }
                    return data
                })
                break;
            case 'Vehicle Note':
                csvData = filteredData.map(item => {

                    const data = {
                        'Submitted By': item.submittedBy,
                        'Created Date': convertToBaseFormatDate(item.createdAt, true),
                        'Note Tag': item.noteTag,
                        'VIN': item?.vin ?? item?.vehicleDetails?.vin ?? item?.vehicleDetails?.vin ?? item?.leverVehicleDetails?.vin ?? '',
                        'Asset Name': item?.vehicleName ?? item?.vehicleDetails?.vehicleName ?? item?.leverVehicleDetails?.vehicleName ?? '',
                    };
                    if (item && item.metadata && item.metadata.taskName) {
                        data['Note'] = item.metadata.taskName;
                        data['Reason'] = viewNotesformatter(item.notes);
                    }
                    else if (item?.metadata?.rejectTask?.length > 0) {
                        const narrativeItem = item?.metadata?.rejectTask.find(task => task.key === 'Narrative');
                        const reasonItem = item?.metadata?.rejectTask.find(task => task.key === 'Reason');

                        if (narrativeItem && reasonItem) {
                            data['Narrative'] = narrativeItem.value;
                            data['Reason'] = reasonItem.value;
                        }
                    }

                    else {
                        data['Note'] = viewNotesformatter(item.notes);
                    }
                    return data
                })
                break;
            case 'Title Note':
                csvData = filteredData.map(item => {
                    const data = {
                        'Submitted By': item.submittedBy,
                        'Created Date': convertToBaseFormatDate(item.createdAt, true),
                        'Note Tag': item.noteTag,
                        'VIN': item?.vehicleDetails?.vin ?? '',
                        'Asset Name': item?.vehicleDetails?.vehicleName ?? ''
                    }
                    if (item && item.metadata && item.metadata.taskName) {
                        data['Note'] = item.metadata.taskName;
                        data['Reason'] = viewNotesformatter(item.notes);
                    } else {
                        data['Note'] = viewNotesformatter(item.notes);
                    }
                    return data
                })
                break;
            case 'Lender Note':
                csvData = filteredData.map(item => {
                    return {
                        'Note': viewNotesformatter(item.notes),
                        'VIN': item.vehicleDetails?.vin,
                        'Asset Name': item.vehicleDetails?.vehicleName,
                        'Submitted By': item.submittedBy,
                        'Created Date': convertToBaseFormatDate(item.createdAt, true),
                        'Note Tag': item.noteTag,
                    }
                })
                break;
            case 'In Person Note':
                csvData = filteredData.map(item => {
                    return {
                        'VIN': item.vin,
                        'Asset Name': item.vehicleName,
                        'Status': item.leverAuditStatus,
                        'Audit Date': convertToBaseFormatDate(item.audit_start_date),
                        'Name': item.quicktrack_name,
                        'Date Out': convertToBaseFormatDate(item.quicktrack_dateOut),
                        'Funding Date': convertToBaseFormatDate(item.fundedDate),
                        'Auditor Notes': item.quicktrack_notes
                    }
                })
                break;
            case 'Virtual Note':
                csvData = filteredData.map(item => {
                    return {
                        'Audit Id': item.audit_id,
                        'Audit Date': convertToBaseFormatDate(item.datetime),
                        'Auditor Notes': item.comment
                    }
                })
                break;
            case 'Supplier Note':
                csvData = filteredData.map(item => {
                    return {
                        'Note': viewNotesformatter(item.notes),
                        'Submitted By': item.submittedBy,
                        'Created Date': convertToBaseFormatDate(item.createdAt, true),
                        'Note Tag': item.noteTag,

                    }
                })
                break;
            case 'History':
                csvData = filteredData.map(item => {
    
                    return {
                        'Activity': viewNotesformatter(item.notes),
                        'Submitted By': item.submittedBy,
                        'Created Date': convertToBaseFormatDate(item.createdAt, true),
                        'Notes': item.noteTag,
    
                    }
                })
                break;

        }

        printRT = filteredData.map((data, index) => {
            if (tableHeaderData) {

                return (
                    <tr key={'notes' + index}>
                        {
                            tableHeaderData.map(item => {
                                if (item.type === "date") {

                                    return (
                                        <td>
                                            <p style={{ minWidth: '100px' }}>{convertToBaseFormatDate(data[item.key], true)}</p>
                                        </td>
                                    )
                                }
                                else if (item.key === "vin,vehicleName") {

                                    const vehicleDataType = (value) => {

                                        if (data[value]) {
                                            return data[value]
                                        }
                                        else if (data.vehicleDetails && data.vehicleDetails[value]) {
                                            return data.vehicleDetails[value]
                                        }
                                        else if (data.leverVehicleDetails && data.leverVehicleDetails[value]) {
                                            return data.leverVehicleDetails[value]
                                        }
                                        else {
                                            return ""
                                        }

                                    }
                                    return (
                                        <td>
                                            <p className="bold-500">{vehicleDataType(item.key.split(',')[1])}</p>
                                            <p>{vehicleDataType(item.key.split(',')[0])}</p>
                                        </td>
                                    )
                                } else if (item.key === "submittedBy") {

                                    return (
                                        <td>
                                            <p style={{ minWidth: '100px' }}>{data[item.key]}</p>
                                        </td>
                                    )
                                }
                                else if (item.key === "notes,description") {

                                    return (
                                        <td>
                                            {data?.metadata?.taskName ? <div>
                                                <p>{data.metadata.taskName}</p>
                                                <p className="content-sm-text mb-1"><span >Reason: </span>
                                                    <span className=" cursor-pointer">{parse(data.notes)}</span></p>
                                            </div> : <p>{parse(data.notes)}</p>}
                                        </td>
                                    )
                                }

                                // else if (item.key === 'notes') {
                                //     return (
                                //         <td>
                                //             <p>{parse(data[item.key])}</p>
                                //         </td>
                                //     )
                                // }
                                else if (item.key === "notes") {
                                    return (<td>
                                        {data?.metadata?.rejectTask?.length > 0 ?
                                            (data.metadata.rejectTask.map((item, index) => (
                                                <p>
                                                    <span>{item.key}: </span>
                                                    <span>{item.value}</span>
                                                </p>
                                            ))) : data?.metadata?.taskName ? <div>
                                                <p>{data.metadata.taskName}</p>
                                                <p><span>Reason: </span>
                                                    <span>{parse(data.notes)}</span></p>
                                            </div> : <p>{parse(data.notes)}</p>}
                                            {data.paymentDetails?.paymentType ? <small>Payment Type: {data.paymentDetails?.paymentType}</small>:null}
                                    </td>)
                                }

                                else {

                                    return (
                                        <td>
                                            <p>{data[item.key]}</p>
                                        </td>
                                    )
                                }
                            })

                        }
                    </tr>
                )
            }
        });

    };

    const viewDocumentById = (item) => {

        return callAPI.post('/lender/api/v1/dealer/getTitleDocumentUrl', { _id: item._id, noteType: props.activeTabName }).then((response) => {
            if (response.status === 200) {
                viewDocument(response.data.fileType, response.data.url)
            } else {
                console.log(response.message)
            }
        })

    }

    const setFilteredData = useCallback((filteredData, activeTabInViewPort) => {
        if (!showFilters) {
            setCSVData(filteredData, activeTabInViewPort);
        }

    }, [props.tableData.sharedTableData]);

    const handlePrint = useReactToPrint({
        content: () => printRef.current,
    });

    const deleteNote = (itemID) => {
        props.deleteNoteHandler(itemID)
    }

    const editNote = (e, item) => {
        props.editNoteHandler(e, item, true)
    }

    const createNote = (e, item) => {
        props.editNoteHandler(e, item, false)
    }

    useEffect(() => {
        if (rerenderPrintData !== undefined)
            handlePrint();

    }, [rerenderPrintData]);



    // useEffect(() => {

    //     if (props.tableData) {

    //         let _notesColumn = [];

    //         if (props.tableData.auditHeaders && props.auditoryNote) {

    //             for (let i = 0; i < props.tableData.auditHeaders.length; i++) {
    //                 if (props.tableData.auditHeaders[i].type === "date") {
    //                     _notesColumn.push({
    //                         Header: props.tableData.auditHeaders[i].label,
    //                         accessor: props.tableData.auditHeaders[i].key,
    //                         filter: filterDateRange,
    //                         Filter: DateRangeFilter,
    //                         Cell: localProps => <p>{convertToBaseFormatDate(localProps.value, true)}</p>
    //                     })
    //                 } else if (props.tableData.auditHeaders[i].label.toLowerCase() === 'vehicle details') {
    //                     _notesColumn.push({
    //                         Header: props.tableData.auditHeaders[i].label,
    //                         // accessor: props.tableData.header[i].key.split(',')[0] + props.tableData.header[i].key.split(',')[1],
    //                         accessor: row => row.vehicleName + row.vin,
    //                         filter: 'contains',
    //                         Cell: localProps =>
    //                             <p class="mb-0" style={{ maxWidth: '250px' }}>
    //                                 <span class="bold-500 blue-link-text">{localProps.row.original.vehicleName}</span>
    //                                 <span class="bold-400 content-text-14px d-block">{localProps.row.original.vin}</span>
    //                             </p>
    //                     })
    //                 } else if (props.tableData.auditHeaders[i].type === "string") {
    //                     _notesColumn.push({
    //                         Header: props.tableData.auditHeaders[i].label,
    //                         accessor: props.tableData.auditHeaders[i].key,
    //                         filter: 'contains',
    //                         Cell: localProps => <p>{localProps.value}</p>
    //                     })
    //                 } else {
    //                     _notesColumn.push({
    //                         Header: props.tableData.auditHeaders[i].label,
    //                         accessor: props.tableData.auditHeaders[i].key,
    //                         filter: 'contains',
    //                         Cell: localProps => <p>{localProps.value}</p>
    //                     })
    //                 }
    //             }
    //         } else if (props.tableData.header) {

    //             for (let i = 0; i < props.tableData.header.length; i++) {
    //                 if (props.tableData.header[i].type === "date") {
    //                     _notesColumn.push({
    //                         Header: props.tableData.header[i].label,
    //                         accessor: props.tableData.header[i].key,
    //                         filter: filterDateRange,
    //                         Filter: DateRangeFilter,
    //                         Cell: localProps => <p>{convertToBaseFormatDate(localProps.value, true)}</p>
    //                     })
    //                 } else if (props.tableData.header[i].label.toLowerCase() === 'vehicle details') {
    //                     _notesColumn.push({
    //                         Header: props.tableData.header[i].label,
    //                         // accessor: props.tableData.header[i].key.split(',')[0] + props.tableData.header[i].key.split(',')[1],
    //                         accessor: row => row.vehicleName + row.vin,
    //                         filter: 'contains',
    //                         Cell: localProps =>
    //                             <p class="mb-0" style={{ maxWidth: '250px' }}>
    //                                 <span class="bold-500 blue-link-text">{localProps.row.original.vehicleName}</span>
    //                                 <span class="bold-400 content-text-14px d-block">{localProps.row.original.vin}</span>
    //                             </p>
    //                     })
    //                 } else if (props.tableData.header[i].label.toLowerCase() === 'note') {
    //                     _notesColumn.push({
    //                         Header: props.tableData.header[i].label,
    //                         // accessor: props.tableData.header[i].key.split(',')[0] + props.tableData.header[i].key.split(',')[1],
    //                         accessor: row => row.notes,
    //                         filter: 'contains',
    //                         Cell: localProps =>
    //                             <p>{localProps.value}

    //                                 {localProps.row.original.paymentDetails ?
    //                                     <OverlayTrigger placement="bottom"
    //                                         overlay={
    //                                             <Popover>
    //                                                 <Popover.Content>
    //                                                     <p className="text-left"><span className="bold-600">Payment Amount: </span> {currencifyInDollars(localProps.row.original.paymentDetails.paymentAmount)}</p>
    //                                                     <p className="text-left"><span className="bold-600">Payment Date: </span> {convertToBaseFormatDate(localProps.row.original.paymentDetails.paymentDate)}</p>
    //                                                     <p className="text-left"><span className="bold-600">Payment Type: </span>{localProps.row.original.paymentDetails.paymentDescription}</p>
    //                                                 </Popover.Content>
    //                                             </Popover>}>
    //                                         <span> <Info className="icon-active-color cursor-pointer" size={18} /> </span>
    //                                     </OverlayTrigger> : null}
    //                             </p>
    //                     })
    //                 } else if (props.tableData.header[i].label.toLowerCase() === 'note tag') {
    //                     _notesColumn.push({
    //                         Header: props.tableData.header[i].label,
    //                         accessor: props.tableData.header[i].key,
    //                         filter: filterNoteTag,
    //                         Filter: SelectNoteTagFilter,
    //                         Cell: localProps =>
    //                             <p>
    //                                 <span>{localProps.value}</span>
    //                                 <Dropdown className='lender-pipeline-dropdown-in-table dropdown-action-items inline-block'>
    //                                     <Dropdown.Toggle variant="success" id="dropdown-basic">
    //                                         <MoreVertical className="blue-link-text cursor-pointer" size={16} />
    //                                     </Dropdown.Toggle>

    //                                     <Dropdown.Menu className='content-text-14px'>
    //                                         < Dropdown.Item
    //                                             onClick={(event) => editNote(event, localProps.row.original)}
    //                                         >
    //                                             <Edit size={18} className="icon-active-color width-20px" />   Edit Note
    //                                         </Dropdown.Item>
    //                                         < Dropdown.Item
    //                                             onClick={(event) => deleteNote(localProps.row.original._id)}
    //                                         >
    //                                             <Trash2 size={18} className="icon-active-color width-20px" />  Delete Note
    //                                         </Dropdown.Item>
    //                                     </Dropdown.Menu>
    //                                 </Dropdown>
    //                             </p>
    //                     })
    //                 } else if (props.tableData.header[i].type === "string") {
    //                     _notesColumn.push({
    //                         Header: props.tableData.header[i].label,
    //                         accessor: props.tableData.header[i].key,
    //                         filter: 'contains',
    //                         Cell: localProps => <p>{localProps.value}</p>
    //                     })
    //                 } else {
    //                     _notesColumn.push({
    //                         Header: props.tableData.header[i].label,
    //                         accessor: props.tableData.header[i].key,
    //                         filter: 'contains',
    //                         Cell: localProps => <p>{localProps.value}</p>
    //                     })
    //                 }
    //             }
    //         }


    //         setNotesColumn(_notesColumn)
    //     }

    // }, [props.tableData])

    useEffect(() => {
        setActiveTabInViewPort(
            props.innerTab ? props.innerTab : props.activeTabName ? props.activeTabName : ''
        )
        if (props.tableData && props.tableData.sharedTableData && props.tableData.sharedTableData.length > 0) {

            let _notesColumn = [];

            for (let i = 0; i < props.tableData.sharedTableHeaders.length; i++) {
                if (props.tableData.sharedTableHeaders[i].type === "date") {
                    _notesColumn.push({
                        Header: props.tableData.sharedTableHeaders[i].label,
                        accessor: props.tableData.sharedTableHeaders[i].key,
                        filter: filterDateRange,
                        Filter: DateRangeFilter,
                        className: 'date-in-table',
                        Cell: localProps => <small className="dateandtime-in-table time-in-balck-color">{convertToBaseFormatDate(localProps.value, true)}</small>
                    })
                } else if (['vehicle details', 'asset details'].includes(props.tableData?.sharedTableHeaders[i]?.label?.toLowerCase())) {
                    _notesColumn.push({
                        Header: props.tableData.sharedTableHeaders[i].label,
                        // accessor: props.tableData.header[i].key.split(',')[0] + props.tableData.header[i].key.split(',')[1],
                        accessor: row => (row?.vehicleName ?? row?.vehicleDetails?.vehicleName ?? row?.leverVehicleDetails?.vehicleName ?? '') + (row?.vin ?? row?.vehicleDetails?.vin ?? row?.leverVehicleDetails?.vin ?? ''),
                        filter: 'contains',
                        className: 'vehicle-details-in-table',
                        Cell: localProps =>
                        (localProps.row.original.recoveryAmount ?
                            <p>
                                <b>{localProps.row.original.year ? localProps.row.original.year : null} {localProps.row.original.model ? localProps.row.original.model : null} {localProps.row.original.make ? localProps.row.original.make : null} {localProps.row.original.color ? "- " + localProps.row.original.color : null}</b>
                                <small>{localProps.row.original.dealerCollateralVin ? localProps.row.original.dealerCollateralVin : null}</small>
                            </p>
                            :
                            <p>
                                <b>{localProps.row.original?.vehicleName ?? localProps.row.original.vehicleDetails?.vehicleName ?? localProps.row.original.leverVehicleDetails?.vehicleName ?? ''}</b>
                                <small>{localProps.row.original?.vin ?? localProps.row.original?.vehicleDetails?.vin ?? localProps.row.original?.leverVehicleDetails?.vin ?? ''}</small>
                            </p>)
                    })
                } else if (props.tableData.sharedTableHeaders[i].label.toLowerCase() === 'note') {
                    _notesColumn.push({
                        Header: props.tableData.sharedTableHeaders[i].label,
                        // accessor: props.tableData.header[i].key.split(',')[0] + props.tableData.header[i].key.split(',')[1],
                        accessor: row => row.notes + row.taskName,
                        filter: 'contains',
                        className: 'note-in-table',
                        Cell: localProps =>
                            <p>
                                {localProps.row.original?.metadata?.taskName ? <div>
                                    <p>{localProps.row.original.metadata.taskName}
                                        {localProps.row.original.paymentDetails ?
                                            <OverlayTrigger placement="top"
                                                overlay={
                                                    <Popover>
                                                        <Popover.Content>
                                                            <small className="d-block">Payment Amount: {currencifyInDollars(localProps.row.original.paymentDetails.paymentAmount)}</small>
                                                            <small className="d-block">Payment Date: {convertToBaseFormatDate(localProps.row.original.paymentDetails.paymentDate)}</small>
                                                            <small className="d-block">Payment Type: {localProps.row.original.paymentDetails.paymentDescription}</small>
                                                        </Popover.Content>
                                                    </Popover>}>
                                                {/* <span> 
                                            <Info style={{ marginTop: '-2px' }} className="icon-active-color cursor-pointer" size={16} /> </span> */}
                                                <Image src={InfoIcon} alt="Info Icon" />
                                            </OverlayTrigger> : null}</p>
                                    <p><span>Reason: </span>
                                        <span className="cursor-pointer">{localProps.row.original.notes ? parse(localProps.row.original.notes) : ''}</span></p>
                                </div> :
                                    <p className="secondary-text-color">
                                        {
                                            localProps.row.original?.metadata?.rejectTask?.length > 0 ? localProps.row.original.metadata.rejectTask
                                                .map((item => (
                                                    <p ><span>{item.key}: </span>
                                                        <span className="cursor-pointer">
                                                            {
                                                                item.value
                                                            }</span>
                                                    </p>
                                                )))
                                                :
                                                (localProps.row.original.recoveryAmount ?
                                                    <>
                                                        {localProps.row.original.notes ? <p>{localProps.row.original && localProps.row.original.notes ? parse(localProps.row.original.notes) : ''}</p> : null}
                                                        {localProps.row.original.recoveryAmount ? <small className="d-block">Recovery Amount: {localProps.row.original && localProps.row.original.recoveryAmount ? currencifyInDollars(localProps.row.original.recoveryAmount) : ''}</small> : null}
                                                        {localProps.row.original.auction ? <small className="d-block">Auction / Location Of Sale: {localProps.row.original && localProps.row.original.auction ? localProps.row.original.auction : ''}</small> : null}
                                                        {localProps.row.original.netProceeds ? <small className="d-block">Net Proceeds: {localProps.row.original && localProps.row.original.netProceeds ? currencifyInDollars(localProps.row.original.netProceeds) : ''}</small> : null}
                                                        {localProps.row.original.grossProceeds ? <small className="d-block">Gross Proceeds: {localProps.row.original && localProps.row.original.grossProceeds ? currencifyInDollars(localProps.row.original.grossProceeds) : ''}</small> : null}
                                                        {localProps.row.original.dateOfSale ? <small className="d-block">Date Of Sale: {localProps.row.original && localProps.row.original.dateOfSale ? convertToBaseFormatDate(localProps.row.original.dateOfSale, true, false) : ''}</small> : null}

                                                    </> :
                                                    <>
                                                        <p>
                                                            {localProps.row.original.notes ? parse(localProps.row.original.notes) : ''}
                                                        </p>
                                                        {localProps.row.original?.metadata?.reason ? (
                                                            <p className="content-sm-text mb-1">
                                                                <span>Reason: </span>
                                                                <span className="cursor-pointer">
                                                                    {localProps.row.original?.metadata?.reason}
                                                                </span>
                                                            </p>
                                                        ) : null}
                                                    </>

                                                )
                                        }


                                        <small className="d-block">
                                            {localProps?.row?.original?.document && Object.keys(localProps.row.original.document).length > 0 ?
                                                <React.Fragment>
                                                    Attachment:
                                                    <OverlayTrigger placement="bottom"
                                                        overlay={
                                                            <Tooltip>View</Tooltip>}>
                                                        <Image onClick={() => viewDocumentById(localProps.row.original)}
                                                            src={eyeIcon} className="cursor-pointer ml-1" alt="viewIcon" />
                                                    </OverlayTrigger>
                                                </React.Fragment>
                                                : null}
                                        </small>
                                    </p>

                                }
                               {localProps.row.original?.paymentDetails?.paymentType ? <small>Payment Type: {localProps.row.original.paymentDetails?.paymentType}</small>: null}
                            </p>
                    })
                } else if (props.tableData.sharedTableHeaders[i].label.toLowerCase() === 'status') {
                    _notesColumn.push({
                        Header: props.tableData.sharedTableHeaders[i].label,
                        accessor: row => row.leverAuditStatus,
                        filter: 'contains',
                        className: 'status-in-table',
                        Cell: localProps =>
                            <span className="d-flex align-items-start audits-status">
                                <SharedChips
                                    type='auditStatusTag'
                                    label={localProps.value}
                                    dynamicColor={localProps.row.original.color}
                                    inlineBlock={true}
                                />
                            </span>
                    })
                } else if (props.tableData.sharedTableHeaders[i].label.toLowerCase() === 'note tag') {
                    _notesColumn.push({
                        Header: props.tableData.sharedTableHeaders[i].label,
                        accessor: props.tableData.sharedTableHeaders[i].key,
                        filter: filterNoteTag,
                        Filter: SelectNoteTagFilter,
                        className: 'notetag-in-table',
                        Cell: localProps =>
                            <p>
                                <span>{localProps.value}</span>
                            </p>
                    })
                } else if (props.tableData.sharedTableHeaders[i].label.toLowerCase() === 'actions') {
                    _notesColumn.push({
                        Header: props.tableData.sharedTableHeaders[i].label,
                        accessor: '',
                        filter: '',
                        Filter: '',
                        Cell: localProps =>
                            <p>
                                <Dropdown className='default-table-actions-dd'>
                                    <Dropdown.Toggle variant="success" id="dropdown-basic">
                                        <MoreVertical className="cursor-pointer" size={16} />
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu popperConfig={{
                                        strategy: "fixed"
                                    }}>
                                        <Dropdown.Item
                                            onClick={(event) => editNote(event, localProps.row.original)}
                                        >
                                            <span><Image src={BorderEditIcon} /></span>
                                            <span>Edit Note</span>
                                        </Dropdown.Item>
                                        <Dropdown.Item
                                            onClick={(event) => deleteNote(localProps.row.original._id)}
                                        >
                                            <span><Image src={CloseIcon} width={19} /></span>
                                            <span>Delete Note</span>
                                        </Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </p>
                    })
                } else if (props.tableData.sharedTableHeaders[i].type === "string") {
                    _notesColumn.push({
                        Header: props.tableData.sharedTableHeaders[i].label,
                        accessor: props.tableData.sharedTableHeaders[i].key,
                        filter: 'contains',
                        className: 'textcol-in-table',
                        Cell: localProps => <p>{localProps.value}</p>
                    })
                } else {
                    _notesColumn.push({
                        Header: props.tableData.sharedTableHeaders[i].label,
                        accessor: props.tableData.sharedTableHeaders[i].key,
                        filter: 'contains',
                        className: 'other-in-table',
                        Cell: localProps => <p>{localProps.value}</p>
                    })
                }
            }


            setNotesColumn(_notesColumn)
        }


    }, [props.tableData.sharedTableData])


    useEffect(() => {
        setCSVData(props.tableData.sharedTableData
            ? props.tableData.sharedTableData : csvData, activeTabInViewPort)

    }, [activeTabInViewPort, props.activeTabName, props.tableData.sharedTableData]);

    return (
        <div className={`${userDetails.readOnlyAccess || props.onlyViewAccess ? 'read-only-access' : ''}`}>
            <TableFiltersWrapper>
                {props.tableData && props.tableData.sharedTableData && props.tableData.sharedTableData.length > 0 ?
                    <div className={`${props.onlyViewAccess ? '' : 'addNotesFilter-wrapper'}`}>
                        {!showFilters ?
                            <OverlayTrigger placement="bottom"
                                overlay={
                                    <Tooltip>Filter</Tooltip>}>
                                <Button className="action-item anchor-btn" onClick={() => setShowFilters(!showFilters)}>
                                    <img src={filterlogo} alt="printlogo" />
                                </Button>
                            </OverlayTrigger> :
                            <OverlayTrigger placement="bottom"
                                overlay={
                                    <Tooltip>Filter</Tooltip>}>
                                <Button className="action-item active-icon" onClick={() => setShowFilters(!showFilters)}>
                                    <img src={filterlogo} alt="printlogo" />
                                </Button>
                            </OverlayTrigger>
                        }
                        <OverlayTrigger placement="bottom"
                            overlay={
                                <Tooltip>Print</Tooltip>}>
                            <Button onClick={() => setRerenderPrintData(!rerenderPrintData)} className="action-item anchor-btn">
                                <img src={printlogo} alt="printlogo" />
                            </Button>
                        </OverlayTrigger>
                        <OverlayTrigger placement="bottom"
                            overlay={
                                <Tooltip>Download</Tooltip>}>
                            <CSVLink asyncOnClick={true} onClick={() => setRerenderCSVData(!rerenderCSVData)} data={csvData} filename={(activeTabInViewPort === 'Vehicle Note' ? 'Asset Note' : activeTabInViewPort) + '.csv'} className="action-item" target="_blank">
                                <img src={exportlogo} alt="printlogo" />
                            </CSVLink>
                        </OverlayTrigger>

                    </div> : null}

                {
                    storeData?.createNotesData?.showAddNote ?
                        <OverlayTrigger placement="bottom"
                            overlay={
                                <Tooltip>Add Note</Tooltip>} >
                            <Button className="action-item anchor-btn addIconClipboard" onClick={(event) => createNote(event, storeData?.createNotesData?.notesData)}>
                                <img src={AddNoteIcon} alt="printlogo" />
                            </Button>
                        </OverlayTrigger> : null
                }
            </TableFiltersWrapper>



            {/* {
                props.showAuditNotes ?

                    <Row className="default-cs-table m-0">
                        {props.tableData && props.tableData.auditData && props.tableData.auditData.length > 0 ?
                            <Col className="p-0">
                                <ReactTable
                                    columns={notesColumn}
                                    data={props.tableData.auditData}
                                    showFilters={showFilters}
                                    autoResetFilters={!showFilters}
                                    filteredDataSync={(items) => setCSVData(items)}
                                />
                            </Col>
                            :
                            <Col className="text-center p-2"><Image src={NoDataImage} /></Col>
                        }
                    </Row>
                    :

                    <Row className="default-cs-table m-0">
                        {props.tableData && props.tableData.data && props.tableData.data.length > 0 ?
                            <Col className="p-0">
                                <ReactTable
                                    columns={notesColumn}
                                    data={props.tableData.data}
                                    showFilters={showFilters}
                                    autoResetFilters={!showFilters}
                                    filteredDataSync={(items) => setCSVData(items)}
                                />
                            </Col>
                            :
                            <Col className="text-center p-2"><Image src={NoDataImage} /></Col>
                        }
                    </Row>} */}

            <Row className={`default-cs-table m-0 shared-note-table-wrapper ${ props.tableData?.sharedTableHeaders && props.tableData.sharedTableHeaders.length > 0 ? '' : 'actionsItemsTable'}`}>
                {props.tableData && props.tableData.sharedTableData && props.tableData.sharedTableData.length > 0 ?
                    <Col className={`p-0 ${activeTabInViewPort === 'Dealer Note' ? 'dealer-notes-table' : ''} ${props.tableData && props.tableData.sharedTableData && props.tableData.sharedTableData.length === 1 ? 'single-row-noteTag' : (props.tableData && props.tableData.sharedTableData && props.tableData.sharedTableData.length === 2 ? 'two-row-noteTag' : (props.tableData && props.tableData.sharedTableData && props.tableData.sharedTableData.length === 3 ? 'three-row-noteTag' : ''))}`}>
                        <ReactTable
                            columns={userDetails.readOnlyAccess || props.onlyViewAccess ? notesColumn.filter(column => column.Header.toLowerCase() !== 'actions') : notesColumn}
                            data={props.tableData.sharedTableData}
                            showFilters={showFilters}
                            autoResetFilters={!showFilters}
                            filteredDataSync={(items) => setFilteredData(items, activeTabInViewPort)}
                        />
                    </Col>
                    :
                    // <Col className="text-center p-2"><Image src={NoDataImage} /></Col>
                    <NoDataFound />
                }
            </Row>
            <div className="default-print-table d-none">
                <Row ref={printRef}>
                    <Col xs={12}>
                        <Row className="mb-3 align-items-center">
                            <Col xs={4}>
                                <Image width={80} src={partnerDetails && partnerDetails.partnerLogo ? partnerDetails.partnerLogo : logo} fluid />
                            </Col>
                            <Col xs={4} className="prinTableHeading text-center position-absolute">
                                <h3>{(props.activeTabName === 'Vehicle Note' ? 'Asset Note' :  props.activeTabName)}</h3>
                                Lender : {userDetails ? userDetails.dealerName : ''}
                            </Col>
                        </Row>
                    </Col>
                    <Col xs={12} className="left-align-table shared-notes-table table">
                        <Table>
                            <thead className="table-header-bg-color pt-2 pb-2">
                                <tr>
                                    {
                                        props.tableData && props.tableData.sharedTableHeaders && props.tableData.sharedTableHeaders.filter((data) => data.label.toLowerCase() !== 'actions').map((data, index) => {
                                            return (
                                                <th>{data.label}</th>
                                            )
                                        })
                                    }
                                </tr>
                            </thead>
                            <tbody>
                                {printRT}
                            </tbody>
                        </Table>
                    </Col>
                </Row>
            </div>
        </div>
    )
}

export default SharedNotesTable